import React from "react";
import Pattern from "../components/Pattern";
import { NavLink } from "react-router-dom";
import { getPresetPatterns } from "../helpers/PresetPatterns";
import { getCache, checkCacheForSetting, updateCacheValue } from "../helpers/CacheManagement";
import Toggle from "../components/Toggle";
import "../sass/patternlist.scss";

const presets = getPresetPatterns();

class Patterns extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alphabetFilter: "",
      selectedPattern: checkCacheForSetting("pattern"),
      searchTerm: "",
      showRotation: true,
    };
    this.settings = getCache().settings;
    this.presetList = presets.slice(1);
  }

  componentDidMount() {
    document.title = "Let's Play Bingo! | Patterns";
    document.body.addEventListener("scroll", () => {
      if (document.body.scrollTop > 80) {
        document.getElementById("title-bar").classList.add("freeze");
      } else {
        document.getElementById("title-bar").classList.remove("freeze");
      }
    });
    document.addEventListener("togglerotation", (event) => {
      const property = event.detail.property;
      const value = event.detail.value;
      this.setState({ [property]: value });
    });
  }

  componentWillUnmount() {
    document.body.removeEventListener("scroll", () => {
      if (document.body.scrollTop > 80) {
        document.getElementById("title-bar").classList.add("freeze");
      } else {
        document.getElementById("title-bar").classList.remove("freeze");
      }
    });
    document.removeEventListener("togglerotation", (event) => {
      const property = event.detail.property;
      const value = event.detail.value;
      this.setState({ [property]: value });
    });
  }

  updateSelectedPattern = (pattern) => {
    this.setState({ selectedPattern: pattern });
    this.settings.pattern = pattern;
    updateCacheValue("settings", this.settings);
  };

  handleSearch = (event) => {
    this.setState({ searchTerm: event.currentTarget.value });
  };

  handleAlphabetFilter = (event) => {
    const value = event.currentTarget.dataset.letter;
    this.setState({ alphabetFilter: value === this.state.alphabetFilter ? "" : value });
  };

  get visiblePatterns() {
    const searchTerm = this.state.searchTerm.toLowerCase();
    const startsWithValue = this.state.alphabetFilter;

    if (searchTerm === "" && startsWithValue === "") {
      return this.presetList;
    } else {
      let patternsToReturn = [];

      this.presetList.forEach((preset) => {
        // Join all potential names for this pattern
        let values = preset.value + "; " + preset.label;
        if (Object.prototype.hasOwnProperty.call(preset, "otherNames")) {
          values += preset.otherNames.join(";");
        }
        // Create an array of all potential values for starts with filter
        const allVals = values.toLowerCase().split(";");
        // Set a flag for if the pattern should be returned or not, default to no
        let isMatch = false;
        // If the search term is set, check if the names or credited person includes the search term, if so, add the pattern
        if (searchTerm !== "" && (values.toLowerCase().includes(searchTerm) || (preset.credit && preset.credit.toLowerCase().includes(searchTerm)))) {
          isMatch = true;
        }
        // Check if startsWithValue applies
        if (startsWithValue !== "") {
          allVals.forEach((value) => {
            if (value.startsWith(startsWithValue)) {
              isMatch = true;
            }
            if (startsWithValue === "number" && value.charAt(0).match(/\d/)) {
              isMatch = true;
            }
          });
        }

        if (isMatch === true) {
          patternsToReturn.push(preset);
        }
      });
      return patternsToReturn;
    }
  }

  get alphabetFilters() {
    return [
      { label: "#", value: "number", active: this.state.alphabetFilter === "number" },
      { label: "A", value: "a", active: this.state.alphabetFilter === "a" },
      { label: "B", value: "b", active: this.state.alphabetFilter === "b" },
      { label: "C", value: "c", active: this.state.alphabetFilter === "c" },
      { label: "D", value: "d", active: this.state.alphabetFilter === "d" },
      { label: "E", value: "e", active: this.state.alphabetFilter === "e" },
      { label: "F", value: "f", active: this.state.alphabetFilter === "f" },
      { label: "G", value: "g", active: this.state.alphabetFilter === "g" },
      { label: "H", value: "h", active: this.state.alphabetFilter === "h" },
      { label: "I", value: "i", active: this.state.alphabetFilter === "i" },
      { label: "J", value: "j", active: this.state.alphabetFilter === "j" },
      { label: "K", value: "k", active: this.state.alphabetFilter === "k" },
      { label: "L", value: "l", active: this.state.alphabetFilter === "l" },
      { label: "M", value: "m", active: this.state.alphabetFilter === "m" },
      { label: "N", value: "n", active: this.state.alphabetFilter === "n" },
      { label: "O", value: "o", active: this.state.alphabetFilter === "o" },
      { label: "P", value: "p", active: this.state.alphabetFilter === "p" },
      { label: "Q", value: "q", active: this.state.alphabetFilter === "q" },
      { label: "R", value: "r", active: this.state.alphabetFilter === "r" },
      { label: "S", value: "s", active: this.state.alphabetFilter === "s" },
      { label: "T", value: "t", active: this.state.alphabetFilter === "t" },
      { label: "U", value: "u", active: this.state.alphabetFilter === "u" },
      { label: "V", value: "v", active: this.state.alphabetFilter === "v" },
      { label: "W", value: "w", active: this.state.alphabetFilter === "w" },
      { label: "X", value: "x", active: this.state.alphabetFilter === "x" },
      { label: "Y", value: "y", active: this.state.alphabetFilter === "y" },
      { label: "Z", value: "z", active: this.state.alphabetFilter === "z" },
      { label: "All", value: "", active: this.state.alphabetFilter === "" },
    ];
  }

  getVisiblePatternsDisplay = () => {
    if (this.visiblePatterns.length > 0) {
      return this.visiblePatterns.map((preset) => {
        return (
          <div key={preset.value} className="pattern-col col padding-bottom-md">
            <Pattern rotate={this.state.showRotation} editable={false} pattern={preset} selected={this.state.selectedPattern.value === preset.value} showTitle={true} titlePosition="bottom" showCredit={true} showUnusedLetters={true} selectionHandler={this.updateSelectedPattern} />
          </div>
        );
      });
    } else {
      return <div>Sorry! No patterns were found that match those filters.</div>;
    }
  };

  render() {
    return (
      <section className="pattern-list">
        <div className="row container gutters-sm">
          <div className="col full-width no-print">
            <div id="title-bar" className="row align-center">
              <div className="col shrink">
                <h1>Patterns</h1>
              </div>
              <div className="col grow">
                <NavLink to="/" className={({ isActive }) => (isActive ? "hide" : "back-link")}>
                  <button aria-label="Back to Game" className="primary-button">
                    Back to Game
                  </button>
                </NavLink>
                <button
                  aria-label="Print Patterns"
                  className="secondary-button"
                  onClick={() => {
                    window.print();
                    return false;
                  }}>
                  Print Patterns
                </button>
              </div>
            </div>
            <div className="row align-start justify-spread no-print margin-bottom-xlg">
              <div className="col grow padding-horizontal-xxlg">
                <p>Below you will find the full list of preset patterns available for play!</p>
                <p>Below each pattern it will have the pattern name along with credit to the person who submitted it (if applicable). If your game uses the Skip Unused Numbers setting it will display which letter columns will be skipped when the game is in play.</p>
                <p>
                  Searching will look for the search term in the pattern name, credit and other names the pattern is known by. The alphabet filter will show all patterns that start with that letter/number. <strong>Note that patterns may show up that have alternate names that match the chosen filter.</strong>
                </p>
                <p>Clicking on a pattern will set that as the pattern in your current game.</p>
              </div>
              <div className="col shrink padding-top-xlg">
                <div className="total-patterns">
                  <div className="pattern-count">{this.presetList.length}</div>
                  <div className="heading">Total Patterns</div>
                </div>
                <p className="text-center small-text">
                  Updated <strong>6/26/2025</strong>
                </p>
                <p className="text-center small-text">
                  <NavLink to="/submitpattern">Submit yours today!</NavLink>
                </p>
              </div>
            </div>
            <div className="row align-start justify-spread no-print filter-block">
              <div className="col colspan4">
                <label for="searchTerm">Search Patterns:</label>
                <input name="searchTerm" value={this.state.searchTerm} placeholder="Enter pattern name or person credited..." onChange={this.handleSearch} />
                <Toggle disabled={false} eventName="togglerotation" label="Show winning pattern rotations" name="showRotation" value={this.state.showRotation} />
                <div className="x-small-text padding-top-xlg padding-left-sm">
                  Showing <strong>{this.visiblePatterns.length}</strong> of <strong>{this.presetList.length}</strong> total patterns.
                </div>
              </div>
              <div className="col colspan8">
                <label for="alphabetFilters">Filter Patterns:</label>
                <div id="alphabetFilters" className="alphabet-filters">
                  {this.alphabetFilters.map((filter) => (
                    <button key={filter.label} data-letter={filter.value} className={filter.active ? "primary-button alphabet-filter active" : "secondary-button alphabet-filter"} onClick={this.handleAlphabetFilter}>
                      {filter.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col full-width">
            <div className="row">{this.getVisiblePatternsDisplay()}</div>
          </div>
        </div>
      </section>
    );
  }
}

export default Patterns;
